// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","455":"404f4ac0","977":"c7d6623c"}[chunkId] + ".chunk.js";
};